<template>

    <div class="page-container">

        <div class="main">

            <div class="top">
                <h3 class="intro-txt">{{$route.name}}</h3>
            </div>

            <page :url="url" :form="form">

                <template slot="tableSearch">

                    <el-form-item label="提现日期">
                        <el-col :span="11">
                            <el-date-picker type="date" value-format="yyyyMMdd" placeholder="选择交易日期"
                                            v-model="form.startDate" style="width: 100%;"></el-date-picker>
                        </el-col>
                        <el-col class="line" :span="2" style="text-align: center;">-</el-col>
                        <el-col :span="11">
                            <el-date-picker type="date" value-format="yyyyMMdd" placeholder="选择交易日期"
                                            v-model="form.endDate" style="width: 100%;"></el-date-picker>
                        </el-col>
                    </el-form-item>

                </template>

                <template slot="buttonArea">
                    <el-button type="primary" @click="exportDetail" size="small">明细导出</el-button>
                    <!--<el-button type="primary" @click="add" size="small">申请提现</el-button>-->
                </template>

                <template slot="tableColumn">
                    <el-table-column
                            prop="orderId"
                            width="190px"
                            label="平台单号">
                    </el-table-column>

                    <el-table-column
                            prop="tradeOrderId"
                            width="170px"
                            label="商户订单号">
                    </el-table-column>

                    <el-table-column
                            prop="appId"
                            width="150px"
                            label="商户id">
                    </el-table-column>

                    <el-table-column
                            prop="merchantName"
                            width="150px"
                            label="商户名称">
                    </el-table-column>

                    <el-table-column
                            prop="amount"
                            :formatter="$formatter.FenToYuan"
                            width="100px"
                            label="提现金额">
                    </el-table-column>

                    <el-table-column
                            prop="fee"
                            :formatter="$formatter.FenToYuan"
                            width="100px"
                            label="手续费">
                    </el-table-column>

                    <el-table-column
                            prop="actualAmount"
                            :formatter="$formatter.FenToYuan"
                            width="120px"
                            label="实际到账金额">
                    </el-table-column>

                    <el-table-column
                            prop="withdrawType"
                            :formatter="$formatter.formatWithdrawType"
                            width="80px"
                            label="提现类型">
                    </el-table-column>

                    <el-table-column
                            prop="createDate"
                            width="150px"
                            :formatter="$formatter.formatDate"
                            label="创建日期">
                    </el-table-column>

                    <el-table-column
                            prop="createTime"
                            width="150px"
                            :formatter="$formatter.formatDate"
                            label="创建时间">
                    </el-table-column>


                    <el-table-column
                            prop="status"
                            width="100px"
                            :formatter="$formatter.formatWithdrawStatus"
                            label="提现状态">
                    </el-table-column>

                    <el-table-column
                            prop="handleDate"
                            width="150px"
                            :formatter="$formatter.formatDate"
                            label="处理日期">
                    </el-table-column>

                    <el-table-column
                            prop="handleTime"
                            width="150px"
                            :formatter="$formatter.formatDate"
                            label="处理时间">
                    </el-table-column>

                    <el-table-column
                            prop="handleUserName"
                            width="150px"
                            label="处理人">
                    </el-table-column>

                    <el-table-column
                            prop="successDate"
                            width="150px"
                            :formatter="$formatter.formatDate"
                            label="成功日期">
                    </el-table-column>

                    <el-table-column
                            prop="successTime"
                            width="150px"
                            :formatter="$formatter.formatDate"
                            label="成功时间">
                    </el-table-column>

                    <el-table-column
                            prop="callbackStatus"
                            width="150px"
                            label="回调状态">
                    </el-table-column>

                    <el-table-column
                            prop="failReason"
                            width="150px"
                            label="失败原因">
                    </el-table-column>

                    <el-table-column
                            prop="bankName"
                            width="150px"
                            label="银行名称">
                    </el-table-column>

                    <el-table-column
                            prop="branchName"
                            width="150px"
                            label="支行名称">
                    </el-table-column>

                    <el-table-column
                            prop="certName"
                            width="100px"
                            label="姓名">
                    </el-table-column>

                    <el-table-column
                            prop="bankCardNo"
                            width="200px"
                            label="银行卡号">
                    </el-table-column>

                    <el-table-column
                            prop="agentId"
                            width="150px"
                            label="代理商编号">
                    </el-table-column>

                    <el-table-column
                            prop="agentName"
                            width="150px"
                            label="代理商名称">
                    </el-table-column>


                </template>
            </page>

            <MerWithdrawInfoAdd :show.sync="showDialog" :formData="formData" :action="action"></MerWithdrawInfoAdd>

        </div>
    </div>


</template>

<script>
    import Page from '@/components/Page.vue'
    import MerWithdrawInfoAdd from './MerWithdrawInfoAdd'

    export default {
        name: "Systems",
        components: {
            'page': Page,
            MerWithdrawInfoAdd: MerWithdrawInfoAdd
        },

        data() {
            return {
                url: '/withdraw/selectListForMer',
                action: '',
                form: {
                    startDate: "",
                    endDate: ""
                },
                showDialog: false,
                formData: null
            }
        },
        methods: {
            add() {
                this.action = "addWithdraw";
                this.formData = null;
                this.showDialog = true;
            },
            exportDetail() {
                this.axios.get("/withdraw/exportDetailForMer", {params: this.form}).then(res => {
                    if (res.code === 200) {
                        window.location.href = "/common/downloadFile?fileId=" + res.data.fileId;
                    } else {
                        this.$notify.error({
                            title: '提示',
                            message: res.msg
                        });
                    }
                })
            }
        }
    }
</script>

<style scoped>

</style>